import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-acesso-edit',
  templateUrl: './acesso-edit.component.html',
  styleUrl: './acesso-edit.component.css',
  standalone: false
})
export class AcessoEditComponent implements OnInit {

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("access").subscribe((data) => {
      this.fields = data;
    });
  }
  public readonly serviceApi = environment.apiUrl + '/v1/access';

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Controle de Acesso' }, { label: 'Usuários', link: '/access' }, { label: 'Edição' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
    save: 'access',
    // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
}
